import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnterpriseSearchService } from '@sabstravtech/obtservices/angular';
import { LocationDetails, LocationTypes } from '@sabstravtech/obtservices/base';
import { of, Observable, Subject, BehaviorSubject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-search-location-typeahead',
  templateUrl: './search-location-typeahead.html',
  styleUrls: ['./search-location-typeahead.scss'],
  standalone: false
})
export class SearchLocationTypeahead implements OnInit {
  @Input() model;
  @Input() countryCode;
  @Output() modelChange = new EventEmitter<any>();
  @Output() updateElement = new EventEmitter<any>();

  public focus$ = new Subject<string>();
  searchLocationLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  locationTypes = LocationTypes;
  constructor(private searchService: EnterpriseSearchService) {}

  modelChanged(): void {
    this.modelChange.emit(this.model);
  }

  ngOnInit(): void {}

  formatter_rail_air = (x: LocationDetails) => x.name;

  searchLocations = (text$: Observable<string>): Observable<LocationDetails[]> =>
    merge(text$.pipe(debounceTime(1000), distinctUntilChanged()), this.focus$).pipe(
      switchMap((term: string): Observable<LocationDetails[]> => {
        // Don't search if already selected (model is an object) or term too short
        if (typeof this.model === 'object' && this.model !== null) {
          return of([]);
        }
        return term.length <= 2
          ? of([])
          : (this.searchService.getDiscoverLocations(
              term,
              this.searchLocationLoading
            ) as unknown as Observable<LocationDetails[]>);
      })
    );
}
